import { styled } from '@aether/styles'
import {
  AccordionItem,
  AccordionItemsList,
  AccordionHeaderDefault,
} from '@aether/components'
import { InsiderPage } from '@aether/models'
import { PortableText } from '@portabletext/react'

const Root = styled('section', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '$48',

  '@md': {
    gap: '$64',
  },
})

const Title = styled('h2', {
  $aetherFont: 'heading02',
})

const AnswerContent = styled('div', {
  $aetherFont: 'body03',
  paddingBottom: '$32',
})

const AccordionWrapper = styled('section', {
  borderBottom: '1px solid $black',
})

type InsiderPageProps = {
  faq: InsiderPage['faq']
}

export const InsiderAccordion = ({ faq }: InsiderPageProps) => {
  if (!faq?.items?.length) return null

  return (
    <Root>
      {faq.title && <Title>{faq.title}</Title>}
      <AccordionWrapper>
        <AccordionItemsList accordionId="insider-faq">
          {(handleRequestOpen, handleRequestClose, isActive, accordionId) =>
            (faq.items ?? [])
              .filter((item) => item.question && item.answer)
              .map((item, index) => {
                const itemId = `${accordionId}-${index}`

                return (
                  <AccordionItem
                    key={itemId}
                    itemId={itemId}
                    onRequestOpen={handleRequestOpen}
                    onRequestClose={handleRequestClose}
                    isActive={isActive(itemId)}
                    headerComponent={({ isActive }) => (
                      <AccordionHeaderDefault isActive={isActive}>
                        {item.question}
                      </AccordionHeaderDefault>
                    )}
                  >
                    {item.answer && (
                      <AnswerContent>
                        <PortableText value={item.answer} />
                      </AnswerContent>
                    )}
                  </AccordionItem>
                )
              })
          }
        </AccordionItemsList>
      </AccordionWrapper>
    </Root>
  )
}
